import { useCallback, useEffect, useState } from 'react';

const RECAPTCHA_SITE_KEY = '6LcLza4sAAAAAPh0N6xkNozKoMcG2T62vazJ4kK-';

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        ready: (cb: () => void) => void;
        execute: (siteKey: string, options: { action: string }) => Promise<string>;
      };
    };
  }
}

let scriptLoaded = false;

function loadRecaptchaScript() {
  if (scriptLoaded || document.querySelector(`script[src*="recaptcha/enterprise.js"]`)) {
    scriptLoaded = true;
    return;
  }
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  scriptLoaded = true;
}

export function useRecaptcha() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    loadRecaptchaScript();
    let cancelled = false;
    const check = () => {
      if (cancelled) return;
      if (window.grecaptcha?.enterprise) {
        try {
          window.grecaptcha.enterprise.ready(() => {
            if (!cancelled) setReady(true);
          });
        } catch {
          if (!cancelled) setReady(true);
        }
      } else {
        setTimeout(check, 250);
      }
    };
    check();
    return () => { cancelled = true; };
  }, []);

  const executeRecaptcha = useCallback(async (action: string): Promise<string | null> => {
    try {
      if (!window.grecaptcha?.enterprise) {
        console.warn('reCAPTCHA Enterprise not loaded yet');
        return null;
      }
      return await new Promise<string>((resolve, reject) => {
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise
            .execute(RECAPTCHA_SITE_KEY, { action })
            .then(resolve)
            .catch(reject);
        });
      });
    } catch (err) {
      console.error('reCAPTCHA execution failed:', err);
      return null;
    }
  }, []);

  return { executeRecaptcha, ready };
}
